export const paymentsPage = {
  heading: 'payments-page-heading',
  sectionHeading: 'payments-section-heading',
  sectionBody: 'payments-section-body' 
};
